import hoistNonReactStatics from 'hoist-non-react-statics';
import SchemaContext from 'ia-react-core/~/components/schema/_SchemaContext';
import Schema, { DataDstProps, ValuesDstProps } from 'ia-react-core/~/schemas/Schema';
import React, { FC, useContext, useMemo } from 'react';

import getWrappedDisplayName from '../../../utils/hocs/getWrappedDisplayName';

export interface WithSchemaOptions {
  include?: boolean;
  skip?: (props: any) => boolean;
  prefixType?: string;
}

/**
 * @component
 * @visibleName withSchema
 */
export default function withSchema(type: string, { include = false, skip, ...options }: WithSchemaOptions = {}) {
  return (WrappedComponent: FC<(DataDstProps | ValuesDstProps) & { schema?: Schema}>) => {
    const WithSchema = (props: DataDstProps | ValuesDstProps) => {
      const { schema } = useContext(SchemaContext);

      const additionalProps = useMemo(() => include ? { schema } : {}, [schema]);

      // eslint-disable-next-line react-hooks/rules-of-hooks
      const newProps = useMemo(() => (
        schema.decorateComponent(type, props, options)
      ), [props, schema]);

      if (skip?.(props)) {
        return (
          <WrappedComponent
            {...additionalProps}
            {...props}
          />
        );
      }

      return (
        <WrappedComponent
          {...additionalProps}
          {...props}
          {...newProps}
        />
      );
    };

    WithSchema.displayName = getWrappedDisplayName('WithSchema', WrappedComponent);

    return hoistNonReactStatics(WithSchema, WrappedComponent);
  };
}
